import React from "react";

const WhyChooseUs = () => {
  return (
    <div className="section-full site-bg-white twm-w-chooseus-section-wrap wow fadeInDown py-0">
      <div className="container">
        <div className="row twm-w-chooseus-section">
    <div className="section-head left text-center">
              <div className="twm-sm-title left text-center">Our Features</div>
              <h2 className="twm-large-title site-text-dark text-center">
                Why Choose Us?
              </h2>
              {/* <div className="section-head-detail">
                Discover a world of convenience, safety, and customization,
                paving the way for unforgettable adventures and seamless mobility solutions.
              </div> */}
            </div>
          {/* LEFT SIDE */}
          <div className="col-lg-5 col-md-12">

            {/* TITLE */}
        

            {/* LIST */}
            <div className="twm-list-icon-style1">
              <ul>

                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <img src="images/w-choose-icon/icon-1.png" alt="icon" />
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Deals For Every Budget</h3>
                      <p>
                        Incredible prices on every car, van, bike and package worldwide.
                        Book vehicles at incredible prices.
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <img src="images/w-choose-icon/icon-2.png" alt="icon" />
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Flexible Pricing</h3>
                      <p>
                        Customization paving the way for unforgettable adventures
                        and seamless mobility solutions.
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <img src="images/w-choose-icon/icon-3.png" alt="icon" />
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Quality At Minimum Expense</h3>
                      <p>
                        Customization paving the way for unforgettable adventures
                        and seamless mobility solutions.
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="twm-list-icon-style-bx">
                    <div className="twm-icon-bx">
                      <img src="images/w-choose-icon/icon-4.png" alt="icon" />
                    </div>
                    <div className="twm-icon-bx-detail">
                      <h3 className="twm-title">Free Pick-Up & Drop-Off</h3>
                      <p>
                        Enjoy free pickup and drop-off services, adding extra ease
                        to your car rental experience.
                      </p>
                    </div>
                  </div>
                </li>

              </ul>
            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7 col-md-12">
            <div className="twm-w-chooseus-media">

              <div className="twm-media">
                <img src="/images/car2.webp" alt="Support" />
              </div>

              <div className="twm-need-help-bx">
                <div className="twm-need-help-content">
                  <span>Need any help ?</span>
                  <h3 className="twm-title"> +91 9689815477</h3>
                </div>

                <div className="twm-need-help-icon">
                  <img src="images/24-clock.png" alt="24/7 support" />
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;